import instaFetch from './get-instagram'
import sendMail from './send-mail'

export default {
    instaFetch,
    sendMail
}